import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import { 
  EQUIPMENT_STOCK_DETAIL_ITEM_LIST,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_STOCK_DETAIL,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_APPLY_OPTION,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_OPERATION_STATUS,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_FILE,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_ACQUISITION_MODE,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_INSTALLATION_CONDITION,
  EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_SERVICE_TYPE,
  EQUIPMENT_STOCK_DETAIL_ITEM_ADD,
  EQUIPMENT_STOCK_DETAIL_ITEM_DETAIL,
  EQUIPMENT_STOCK_DETAIL_ITEM_UPDATE
} from '../../actions';

import {
  EquipmentStockDetailItemListSuccess,
  EquipmentStockDetailItemListError,
  EquipmentStockDetailItemSearchEquipmentStockDetailSuccess,
  EquipmentStockDetailItemSearchEquipmentStockDetailError,
  EquipmentStockDetailItemSearchApplyOptionSuccess,
  EquipmentStockDetailItemSearchApplyOptionError,
  EquipmentStockDetailItemSearchOperationStatusSuccess,
  EquipmentStockDetailItemSearchOperationStatusError,
  EquipmentStockDetailItemSearchEquipmentFileSuccess,
  EquipmentStockDetailItemSearchEquipmentFileError,
  EquipmentStockDetailItemSearchAcquisitionModeSuccess,
  EquipmentStockDetailItemSearchAcquisitionModeError,
  EquipmentStockDetailItemSearchInstallationConditionSuccess,
  EquipmentStockDetailItemSearchInstallationConditionError,
  EquipmentStockDetailItemSearchServiceTypeSuccess,
  EquipmentStockDetailItemSearchServiceTypeError,
  EquipmentStockDetailItemAddSuccess,
  EquipmentStockDetailItemAddError,
  EquipmentStockDetailItemDetailSuccess,
  EquipmentStockDetailItemDetailError,
  EquipmentStockDetailItemUpdateSuccess,
  EquipmentStockDetailItemUpdateError
} from '../../actions';
 
export function* watchEquipmentStockDetailItemList() {
  yield takeEvery(EQUIPMENT_STOCK_DETAIL_ITEM_LIST, onEquipmentStockDetailItemList);
}

export function* watchEquipmentStockDetailItemSearchEquipmentStockDetail() {
  yield takeEvery(EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_STOCK_DETAIL, onEquipmentStockDetailItemSearchEquipmentStockDetail);
}

export function* watchEquipmentStockDetailItemSearchApplyOption() {
  yield takeEvery(EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_APPLY_OPTION, onEquipmentStockDetailItemSearchApplyOption);
}

export function* watchEquipmentStockDetailItemSearchOperationStatus() {
  yield takeEvery(EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_OPERATION_STATUS, onEquipmentStockDetailItemSearchOperationStatus);
}

export function* watchEquipmentStockDetailItemSearchEquipmentFile() {
  yield takeEvery(EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_EQUIPMENT_FILE, onEquipmentStockDetailItemSearchEquipmentFile);
}

export function* watchEquipmentStockDetailItemSearchAcquisitionMode() {
  yield takeEvery(EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_ACQUISITION_MODE, onEquipmentStockDetailItemSearchAcquisitionMode);
}

export function* watchEquipmentStockDetailItemSearchInstallationCondition() {
  yield takeEvery(EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_INSTALLATION_CONDITION, onEquipmentStockDetailItemSearchInstallationCondition);
}

export function* watchEquipmentStockDetailItemAdd() {
  yield takeEvery(EQUIPMENT_STOCK_DETAIL_ITEM_ADD, onEquipmentStockDetailItemAdd);
}

export function* watchEquipmentStockDetailItemDetail() {
  yield takeEvery(EQUIPMENT_STOCK_DETAIL_ITEM_DETAIL, onEquipmentStockDetailItemDetail);
}

export function* watchEquipmentStockDetailItemUpdate() {
  yield takeEvery(EQUIPMENT_STOCK_DETAIL_ITEM_UPDATE, onEquipmentStockDetailItemUpdate);
}

export function* watchEquipmentStockDetailItemSearchServiceType() {
  yield takeEvery(EQUIPMENT_STOCK_DETAIL_ITEM_SEARCH_SERVICE_TYPE, onEquipmentStockDetailItemSearchServiceType);
}

const onEquipmentStockDetailItemListAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/equipment_stock_detail_item/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onEquipmentStockDetailItemUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/equipment_stock_detail_item/update', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onEquipmentStockDetailItemSearchEquipmentStockDetailAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/assessment/equipment_stock_detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onEquipmentStockDetailItemSearchApplyOptionAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/assessment/apply_option', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onEquipmentStockDetailItemSearchOperationStatusAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/assessment/operation_status', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onEquipmentStockDetailItemSearchEquipmentFileAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/assessment/equipment_file', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onEquipmentStockDetailItemSearchAcquisitionModeAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/assessment/acquisition_mode', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onEquipmentStockDetailItemSearchInstallationConditionAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/assessment/installation_condition', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onEquipmentStockDetailItemSearchServiceTypeAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/assessment/service_type', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onEquipmentStockDetailItemAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/equipment_stock_detail_item/add', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data.payload)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

const onEquipmentStockDetailItemDetailAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/equipment_stock_detail_item/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

function* onEquipmentStockDetailItemList(data) {
  try {
    const response = yield call(onEquipmentStockDetailItemListAsync, data.payload);
    yield put(EquipmentStockDetailItemListSuccess(response.data));
  } catch (error) {
    yield put(EquipmentStockDetailItemListError(error));
  }
}

function* onEquipmentStockDetailItemSearchEquipmentStockDetail(data) {
  try {
    const response = yield call(onEquipmentStockDetailItemSearchEquipmentStockDetailAsync, data.payload);
    yield put(EquipmentStockDetailItemSearchEquipmentStockDetailSuccess(response.data));
  } catch (error) {
    yield put(EquipmentStockDetailItemSearchEquipmentStockDetailError(error));
  }
}

function* onEquipmentStockDetailItemSearchApplyOption(data) {
  try {
    const response = yield call(onEquipmentStockDetailItemSearchApplyOptionAsync, data.payload);
    yield put(EquipmentStockDetailItemSearchApplyOptionSuccess(response.data));
  } catch (error) {
    yield put(EquipmentStockDetailItemSearchApplyOptionError(error));
  }
}

function* onEquipmentStockDetailItemSearchOperationStatus(data) {
  try {
    const response = yield call(onEquipmentStockDetailItemSearchOperationStatusAsync, data.payload);
    yield put(EquipmentStockDetailItemSearchOperationStatusSuccess(response.data));
  } catch (error) {
    yield put(EquipmentStockDetailItemSearchOperationStatusError(error));
  }
}

function* onEquipmentStockDetailItemSearchEquipmentFile(data) {
  try {
    const response = yield call(onEquipmentStockDetailItemSearchEquipmentFileAsync, data.payload);
    yield put(EquipmentStockDetailItemSearchEquipmentFileSuccess(response.data));
  } catch (error) {
    yield put(EquipmentStockDetailItemSearchEquipmentFileError(error));
  }
}

function* onEquipmentStockDetailItemSearchAcquisitionMode(data) {
  try {
    const response = yield call(onEquipmentStockDetailItemSearchAcquisitionModeAsync, data.payload);
    yield put(EquipmentStockDetailItemSearchAcquisitionModeSuccess(response.data));
  } catch (error) {
    yield put(EquipmentStockDetailItemSearchAcquisitionModeError(error));
  }
}

function* onEquipmentStockDetailItemSearchInstallationCondition(data) {
  try {
    const response = yield call(onEquipmentStockDetailItemSearchInstallationConditionAsync, data.payload);
    yield put(EquipmentStockDetailItemSearchInstallationConditionSuccess(response.data));
  } catch (error) {
    yield put(EquipmentStockDetailItemSearchInstallationConditionError(error));
  }
}

function* onEquipmentStockDetailItemSearchServiceType(data) {
  try {
    const response = yield call(onEquipmentStockDetailItemSearchServiceTypeAsync, data.payload);
    yield put(EquipmentStockDetailItemSearchServiceTypeSuccess(response.data));
  } catch (error) {
    yield put(EquipmentStockDetailItemSearchServiceTypeError(error));
  }
}

function* onEquipmentStockDetailItemAdd(data) {
  try {
      const response = yield call(onEquipmentStockDetailItemAddAsync, data);
      yield put(EquipmentStockDetailItemAddSuccess(response.data));
  } catch (error) {
      yield put(EquipmentStockDetailItemAddError(error));
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
  }
}

function* onEquipmentStockDetailItemDetail(data) {
  try {
    const response = yield call(onEquipmentStockDetailItemDetailAsync, data.payload);
    yield put(EquipmentStockDetailItemDetailSuccess(response.data.data));
  } catch (error) {
    yield put(EquipmentStockDetailItemDetailError(error));
  }
}

function* onEquipmentStockDetailItemUpdate(data) {
  try {
      const response = yield call(onEquipmentStockDetailItemUpdateAsync, data.payload);
      yield put(EquipmentStockDetailItemUpdateSuccess(response.data));
  } catch (error) {
      yield put(EquipmentStockDetailItemUpdateError(error));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchEquipmentStockDetailItemList),
    fork(watchEquipmentStockDetailItemSearchEquipmentStockDetail),
    fork(watchEquipmentStockDetailItemSearchApplyOption),
    fork(watchEquipmentStockDetailItemSearchOperationStatus),
    fork(watchEquipmentStockDetailItemSearchEquipmentFile),
    fork(watchEquipmentStockDetailItemSearchEquipmentFile),
    fork(watchEquipmentStockDetailItemSearchAcquisitionMode),
    fork(watchEquipmentStockDetailItemSearchInstallationCondition),
    fork(watchEquipmentStockDetailItemSearchServiceType),
    fork(watchEquipmentStockDetailItemAdd),
    fork(watchEquipmentStockDetailItemDetail),
    fork(watchEquipmentStockDetailItemUpdate),
  ]);
} 